module.exports = __webpack_public_path__ + "img/m-bg5.3ea61ec5.jpg";